import styled from 'styled-components'
// @ts-ignore
import { Scrollama, Step } from 'react-scrollama'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import Chart from './Chart'
import { useEffect, useMemo, useState } from 'react'
import * as d3 from 'd3'
import {
  Small,
  ContentWidth,
  Strong,
  StepContent,
  StepContainer,
} from '../../theme/styles'
// import { throttle } from 'throttle-debounce'

const Scatterplot = () => {
  const [step, setStep] = useState<number>(0)
  const [data, setData] = useState<any>([])

  useEffect(() => {
    d3.csv<any>(
      `${
        process.env.NODE_ENV === 'production'
          ? 'https://dev-interaktiv-mf.tagesanzeiger.ch/2023/seasons'
          : ''
      }/spring-index.csv`,
      (d: any) => {
        return {
          year: +d['year'],
          index: +d['index'],
          mean: +d['mean5year_gauss'],
          note: d['reference_class'],
        }
      }
    )
      .then((data: any) => {
        setData(data)
      })
      .catch((error: any) => {
        console.error('Error fetching the CSV data:', error)
      })
  }, [])

  const onStepEnter = (stepData: any) => {
    setStep(stepData.data)
  }

  return (
    <Scrollyrtelling>
      <StickyChart>
        <ContentWidth>
          <Chart data={data} step={step} />
        </ContentWidth>
        <TextWidth>
          <TextOnColor>
            <Small>
              <strong>Source</strong>: MétéoSuisse
            </Small>
          </TextOnColor>
        </TextWidth>
      </StickyChart>
      <ScrollytellingContainer>
        <Scrollama offset={1} onStepEnter={onStepEnter} on>
          <Step data={0} key={`scrollama-step-${0}`}>
            <StepContainer style={{ height: '25vh' }} />
          </Step>
          <Step data={1} key={`scrollama-step-${1}`}>
            <StepContainer>
              <StepContent>
                <p>
                  Chaque ligne représente{' '}
                  <Strong color='yellow'>l'écart en nombre de jours</Strong>{' '}
                  entre le début du printemps phénologique de chaque année
                  depuis 1954 et la moyenne de la période 1990—2020.
                </p>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={2} key={`scrollama-step-${2}`}>
            <StepContainer>
              <StepContent>
                <p>
                  Les barres jaune clair sont celles qui indiquent un printemps
                  précoce.
                </p>
                <p>
                  On remarque que les périodes de printemps précoce sont{' '}
                  <Strong color='yellow'>de plus en plus fréquentes</Strong>{' '}
                  depuis le début des années 90.
                </p>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={3} key={`scrollama-step-${3}`}>
            <StepContainer>
              <StepContent>
                <p>
                  La moyenne de ces valeurs sur 5 ans permet de réduire la
                  variabilité des données et montre une courbe plus lisible.
                </p>
                <p>
                  Pour la <Strong color='yellow'>première fois</Strong> depuis
                  le début des mesures, celle-ci sort de la déviation normale.
                </p>
              </StepContent>
            </StepContainer>
          </Step>
        </Scrollama>
      </ScrollytellingContainer>
    </Scrollyrtelling>
  )
}

const Scrollyrtelling = styled.div`
  margin-bottom: 60px;
  // background-color: ${({ theme }) => `rgb(${theme.coloredBackground})`};
`

const StickyChart = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
`

const TextOnColor = styled.div`
  // color: ${({ theme }) => `rgb(${theme.textColorOnBackground})`};
  color: var(--text-color);
`

const ScrollytellingContainer = styled.div`
  position: relative;
  width: 100%;
  pointer-events: none;
  margin-top: -120vh;
`

export default Scatterplot
